"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SpendingBlock = _interopRequireDefault(require("../SpendingBlock"));

var _toMoneyFormat = _interopRequireDefault(require("../../utils/toMoneyFormat"));

var _reactScroll = require("react-scroll");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n    position:relative;\n    display: inline-block;\n\n    @media (max-width: ", ") {\n        margin-bottom: 24px;\n        display: block;\n    }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 40px;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    color: ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    margin-right: 64px;\n    color: ", ";\n\n    @media (max-width: ", ") {\n        margin-bottom: 24px;\n        margin-right: 0px;\n        display: block;\n    }\n\n\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    margin-top:8px;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    display:inline-block;\n    font-weight: 600;\n    font-size: 17px;\n    line-height: 26px;\n    margin-left: 8px;\n    color: ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    display:inline-block;\n    position: relative;\n    padding-right: 36px;\n    font-size: 52px;\n    line-height: 65px;\n    color: ", ";\n\n    @media (max-width: ", ") {\n        font-size: 36px;\n        line-height: 48px;\n    }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    font-size: 17px;\n    line-height: 26px;\n    font-weight: 600;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    padding-top: 40px;\n\n    @media (max-width: ", ") {\n      padding-top: 0;\n    }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding-left: 50px;\n\n  @media (max-width: ", ") {\n    padding-top: 12px;\n    padding-left: 0;\n  }\n\n  @media (min-width: ", ") {\n    min-width: 50%;\n    width: 50%;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  @media (min-width: ", ") {\n    min-width: 50%;\n    width: 50%;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display:flex;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #EAEAEA;\n\n\n    @media (max-width: ", ") {\n      display:block;\n    }\n\n    @media (max-width: ", ") {\n      flex-direction: column;\n    }\n\n    @media (min-width: ", ") {\n      padding-bottom: 40px\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    padding: 40px 56px 60px 72px;\n    min-width: 0px;\n    flex-basis: 320px;\n    flex-grow: 1;\n\n    background-color: ", ";\n\n    @media (max-width: ", ") {\n        padding-left: 32px;\n    }\n\n    @media (max-width: ", ") {\n        padding: 20px 16px;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ResultSectionStyled = _styledComponents.default.div(_templateObject(), function (props) {
  return props.theme.backgroundBlue;
}, function (props) {
  return props.theme.breakpointXL;
}, function (props) {
  return props.theme.breakpointMD;
});

var ResultSectionHeader = _styledComponents.default.div(_templateObject2(), function (props) {
  return props.theme.breakpointSM;
}, function (props) {
  return props.theme.breakpointXL;
}, function (props) {
  return props.theme.breakpointXL;
});

var FirstSpendingBlockStyled = _styledComponents.default.div(_templateObject3(), function (props) {
  return props.theme.breakpointXL;
});

var SecondSpendingBlockStyled = _styledComponents.default.div(_templateObject4(), function (props) {
  return props.theme.breakpointXL;
}, function (props) {
  return props.theme.breakpointXL;
});

var ResultSectionBodyStyled = _styledComponents.default.div(_templateObject5(), function (props) {
  return props.theme.breakpointLG;
});

var ResultSectionBodyTitleStyled = _styledComponents.default.div(_templateObject6());

var ResultSummStyled = _styledComponents.default.div(_templateObject7(), function (props) {
  return props.theme.colorDarkGray;
}, function (props) {
  return props.theme.breakpointXS;
});

var ResultSummCurrencyStyled = _styledComponents.default.div(_templateObject8(), function (props) {
  return props.theme.colorDarkGray;
});

var ResultSummWrapperStyled = _styledComponents.default.div(_templateObject9());

var ResultKPPStyled = (0, _styledComponents.default)(ResultSummStyled)(_templateObject10(), function (props) {
  return props.theme.colorMain;
}, function (props) {
  return props.theme.breakpointLG;
});
var ResultKPPCurrencyStyled = (0, _styledComponents.default)(ResultSummCurrencyStyled)(_templateObject11(), function (props) {
  return props.theme.colorMain;
});

var ResultButtonWrapper = _styledComponents.default.div(_templateObject12());

var ResultCellStyled = _styledComponents.default.div(_templateObject13(), function (props) {
  return props.theme.breakpointLG;
});

var ResultSection = function ResultSection(props) {
  var kpp = props.kpp,
      economy = props.economy,
      showKppBudget = props.showKppBudget,
      getValues = props.getValues,
      indexation = props.indexation,
      motivation = props.motivation,
      anchor = props.anchor,
      calculationProps = props.calculationProps,
      results = props.results,
      customResultButton = props.customResultButton,
      showButton = props.showButton;
  var firstSpendingBlock = {
    description: "Дополнительные расходы",
    subDesc: " \u043F\u0440\u0438 \u0438\u043D\u0434\u0435\u043A\u0441\u0430\u0446\u0438\u0438 \u0437\u0430\u0440\u0430\u0431\u043E\u0442\u043D\u043E\u0439 \u043F\u043B\u0430\u0442\u044B \u043D\u0430 ".concat(calculationProps.contribution, "%"),
    summ: Math.round(indexation.fivePercentAdd) + Math.round(indexation.additionalContribution),
    firstSubitem: {
      label: "Рост объема ФОТ после индексации:",
      summ: Math.round(indexation.fivePercentAdd)
    },
    secondSubitem: {
      label: "Доп. страх. взносы:",
      summ: Math.round(indexation.additionalContribution)
    }
  };
  var secondSpendingBlock = {
    description: "Бюджет на внедрение КПП",
    summ: Math.round(motivation.kppContribution) + Math.round(motivation.targetContribution),
    firstSubitem: {
      label: "Стартовый взнос в КПП:",
      summ: Math.round(motivation.kppContribution)
    },
    secondSubitem: {
      label: "Целевой взнос НПФ (2%):",
      summ: Math.round(motivation.targetContribution)
    }
  };
  return /*#__PURE__*/_react.default.createElement(ResultSectionStyled, null, /*#__PURE__*/_react.default.createElement(ResultSectionHeader, null, /*#__PURE__*/_react.default.createElement(FirstSpendingBlockStyled, {
    id: "first-spending-block"
  }, /*#__PURE__*/_react.default.createElement(_SpendingBlock.default, firstSpendingBlock)), /*#__PURE__*/_react.default.createElement(SecondSpendingBlockStyled, {
    id: "second-spending-block"
  }, /*#__PURE__*/_react.default.createElement(_SpendingBlock.default, secondSpendingBlock))), /*#__PURE__*/_react.default.createElement(ResultSectionBodyStyled, null, /*#__PURE__*/_react.default.createElement(ResultSummWrapperStyled, null, showKppBudget && /*#__PURE__*/_react.default.createElement(ResultCellStyled, {
    id: "kppBudget"
  }, /*#__PURE__*/_react.default.createElement(ResultSectionBodyTitleStyled, null, "\u0411\u044E\u0434\u0436\u0435\u0442 \u041A\u041F\u041F"), /*#__PURE__*/_react.default.createElement(ResultKPPStyled, null, (0, _toMoneyFormat.default)(kpp), /*#__PURE__*/_react.default.createElement(ResultKPPCurrencyStyled, null, "\u0440\u0443\u0431."))), /*#__PURE__*/_react.default.createElement(ResultCellStyled, {
    id: "economy"
  }, /*#__PURE__*/_react.default.createElement(ResultSectionBodyTitleStyled, null, "\u042D\u043A\u043E\u043D\u043E\u043C\u0438\u044F \u0434\u043B\u044F \u0432\u0430\u0448\u0435\u0433\u043E \u0431\u0438\u0437\u043D\u0435\u0441\u0430"), /*#__PURE__*/_react.default.createElement(ResultSummStyled, null, (0, _toMoneyFormat.default)(Math.round(firstSpendingBlock.summ) - Math.round(secondSpendingBlock.summ)), /*#__PURE__*/_react.default.createElement(ResultSummCurrencyStyled, null, "\u0440\u0443\u0431.")))), showButton && /*#__PURE__*/_react.default.createElement(ResultButtonWrapper, {
    className: "calculator__button-container"
  }, /*#__PURE__*/_react.default.createElement(_reactScroll.Link, {
    activeClass: "active",
    className: (customResultButton === null || customResultButton === void 0 ? void 0 : customResultButton.classWrapper) || 'calculator__button',
    to: (customResultButton === null || customResultButton === void 0 ? void 0 : customResultButton.to) || anchor,
    spy: true,
    smooth: true,
    duration: 500,
    onClick: function onClick() {
      if (customResultButton !== null && customResultButton !== void 0 && customResultButton.onClick) {
        customResultButton.onClick();
      } else if (getValues) {
        var antikrizis = {
          calculationData: calculationProps,
          calculatedValues: results
        };
        getValues(antikrizis);
      }
    }
  }, (customResultButton === null || customResultButton === void 0 ? void 0 : customResultButton.text) || 'Получить расчет экономии'))));
};

ResultSection.propTypes = {
  calculate: _propTypes.default.func.isRequired,
  anchor: _propTypes.default.string.isRequired,
  getValues: _propTypes.default.func,
  showKppBudget: _propTypes.default.bool,
  showButton: _propTypes.default.bool
};
var _default = ResultSection;
exports.default = _default;